import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import GetAppIcon from "@mui/icons-material/GetApp";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import Typography from "@mui/material/Typography";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LaunchIcon from "@mui/icons-material/Launch";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import ListItemIcon from "@mui/material/ListItemIcon";
import { actionLayerSingleBuildingModeUpdated } from "../Layer";
import { actionAddAlert, actionDeleteAlert } from "../Alert";
import DownloadDialog from "./DownloadDialog";
import PDFDownloadDialog from "./PDFDownloadDialog";
import { actionPhotoPaneToggled, actionPhotoGetTargetRoom } from "../Photo";
import { CopyToClipboard } from "react-copy-to-clipboard";

const moreBtn_ = (theme) => ({
  position: "absolute",
  top: 8,
  right: 0,
});

export default function RoomActions({ room }) {
  const dispatch = useDispatch();

  const { rmrecnbr, rmnbr, bld_descrshort, bldrecnbr, floor } = room;

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [downloadVisible, setDownloadVisible] = useState(false);
  const handleDownloadClick = () => {
    setDownloadVisible(true);
    handleClose();
  };
  const handleDownloadClose = () => {
    setDownloadVisible(false);
  };

  const quitMode = () => {
    dispatch(actionLayerSingleBuildingModeUpdated(null));
    dispatch(actionDeleteAlert("sbv"));
  };
  const singleBuildingMode = useSelector(
    (state) => state.layerReducer.singleBuildingMode,
  );
  const checked = !!singleBuildingMode && !!singleBuildingMode.bldrecnbr;

  const singleBuildingModeClickHandler = () => {
    if (checked) {
      dispatch(actionLayerSingleBuildingModeUpdated(null));
      dispatch(actionDeleteAlert("sbv"));
    } else {
      dispatch(actionLayerSingleBuildingModeUpdated(bldrecnbr));
      dispatch(
        actionAddAlert({
          id: "sbv",
          title: "Single Building View",
          buttonLabel: "QUIT",
          onClick: quitMode,
          onClose: false,
        }),
      );
    }
  };

  const togglePhoto = () => {
    dispatch(actionPhotoPaneToggled(true));
    dispatch(actionPhotoGetTargetRoom(room));
    handleClose();
  };

  const [roomUrlTooltip, setRoomUrlTooltip] = useState("");
  const onCopyHandler = () => {
    setRoomUrlTooltip("COPIED");
    setTimeout(() => {
      setRoomUrlTooltip("");
    }, 1000);
  };

  const [pdfDownloadVisible, setPdfDownloadVisible] = useState(false);
  const handlePdfDownloadClick = () => {
    setPdfDownloadVisible(true);
    handleClose();
  };
  const handlePdfDownloadClose = () => {
    setPdfDownloadVisible(false);
  };

  const mpathwayLink = `https://finprod.dsc.umich.edu/psp/finprod/EMPLOYEE/ERP/c/M_SM_SPACE.M_SM_SVY.GBL?M_SM_BLDRECNBR=${bldrecnbr}&M_SM_FLOOR=${floor}&M_SM_RMNBR=${rmnbr}&SETID=UMICH&PAGE=M_SM_SVY`;

  // Address a Siteimprove complaint that this link was only 14px tall.
  const linkStyle = { display: "inline-block" };

  return (
    <>
      <Tooltip title="More Options">
        <IconButton size="small" sx={moreBtn_} onClick={handleClick}>
          <MoreVertIcon />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={handleDownloadClick}>
          <ListItemIcon>
            <GetAppIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="overline">Data</Typography>
        </MenuItem>
        <MenuItem onClick={handlePdfDownloadClick}>
          <ListItemIcon>
            <PictureAsPdfIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="overline">Floor Plan</Typography>
        </MenuItem>
        <MenuItem onClick={togglePhoto}>
          <ListItemIcon>
            <PhotoCameraIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="overline">Photo</Typography>
        </MenuItem>
        <Tooltip describeChild title={roomUrlTooltip}>
          <span>
            <CopyToClipboard
              text={`${window.location.href}#feature=search&rrn=${rmrecnbr}`}
              onCopy={onCopyHandler}
            >
              <MenuItem>
                <ListItemIcon>
                  <FileCopyIcon fontSize="small" />
                </ListItemIcon>
                <Typography variant="overline">Room URL</Typography>
              </MenuItem>
            </CopyToClipboard>
          </span>
        </Tooltip>
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <LaunchIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="overline">
            <a
              style={linkStyle}
              href={mpathwayLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              M-Pathways
            </a>
          </Typography>
        </MenuItem>
        <MenuItem onClick={singleBuildingModeClickHandler}>
          <ListItemIcon>
            {checked ? (
              <CheckBoxIcon fontSize="small" />
            ) : (
              <CheckBoxOutlineBlankIcon fontSize="small" />
            )}
          </ListItemIcon>
          <Typography variant="overline">Single Building</Typography>
        </MenuItem>
      </Menu>
      <DownloadDialog
        open={downloadVisible}
        onClose={handleDownloadClose}
        bldrecnbr={bldrecnbr}
        name={bld_descrshort}
        floor={floor}
      />
      <PDFDownloadDialog
        open={pdfDownloadVisible}
        onClose={handlePdfDownloadClose}
        bldrecnbr={bldrecnbr}
        name={bld_descrshort}
        floor={floor}
      />
    </>
  );
}
